import { useNavigate } from "react-router-dom";

interface JobsSectionProps {
  jobs: any[];
  onApplyClick: (jobId: number) => void;
}

const companyColors: Record<number, { bg: string; text: string }> = {
  1: { bg: "#EDE9FE", text: "#7C3AED" },
  2: { bg: "#D1FAE5", text: "#065F46" },
  3: { bg: "#FEF9C3", text: "#92400E" },
  4: { bg: "#FEE2E2", text: "#991B1B" },
};

const initials = (name: string) => {
  const words = name.trim().split(" ");
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

const typeLabels: Record<string, string> = {
  'full-time': 'מלאה',
  'part-time': 'חלקית',
  'freelance': 'פרילנס',
};

const typeColors: Record<string, string> = {
  'full-time': '#D1FAE5',
  'part-time': '#FEF9C3',
  'freelance': '#EDE9FE',
};

export default function JobsSection({ jobs, onApplyClick }: JobsSectionProps) {
  const navigate = useNavigate();
  const openJobs = jobs.filter((j) => j.status === "open");

  if (openJobs.length === 0) return null;
  if (openJobs.length > 4) openJobs.length = 4;

  return (
    <section className="py-4" dir="rtl">
      <div className="flex items-center justify-between px-4 mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 flex items-center justify-center rounded-xl border-2 border-gray-900 bg-green-100">
            <i className="ri-briefcase-line text-gray-900 text-base"></i>
          </div>
          <h3 className="text-lg font-black text-gray-900">משרות פתוחות</h3>
        </div>
        <button onClick={() => navigate("/all-jobs")} className="flex items-center gap-1 text-sm font-bold text-gray-500 hover:text-gray-800 transition-colors cursor-pointer whitespace-nowrap">
          הכל <i className="ri-arrow-left-line text-sm"></i>
        </button>
      </div>

      <div className="flex flex-col gap-3 px-4">
        {openJobs.map((job: any, idx: number) => {
          const colors = companyColors[(idx % 4) + 1] ?? { bg: "#F3F4F6", text: "#374151" };
          const typeLabel = typeLabels[job.type] || job.type;
          const typeBg = typeColors[job.type] || "#F3F4F6";

          return (
            <div
              key={job.id}
              onClick={() => navigate(`/item/job-${job.id}`)}
              className="flex items-center gap-3 bg-white rounded-2xl border-[2.5px] border-gray-900 px-4 py-3 cursor-pointer transition-transform hover:-translate-y-0.5"
              dir="rtl"
            >
              <div
                className="w-12 h-12 flex-shrink-0 rounded-2xl border-2 border-gray-900 flex items-center justify-center font-black text-base select-none"
                style={{ background: colors.bg, color: colors.text }}
              >
                {initials(job.company)}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <span className="text-sm font-black text-gray-900 leading-snug line-clamp-1">
                    {job.title}
                  </span>
                  <span
                    className="flex-shrink-0 text-xs font-black border-2 border-gray-900 rounded-full px-2 py-0.5 whitespace-nowrap"
                    style={{ background: typeBg }}
                  >
                    {typeLabel}
                  </span>
                </div>

                <p className="text-xs font-semibold text-gray-500 mt-0.5">{job.company}</p>

                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="flex items-center gap-1 text-xs text-gray-500">
                    <i className="ri-map-pin-line text-gray-400 text-xs"></i>
                    {job.location}
                  </span>
                  
                  
                </div>
              </div>

              <button
                onClick={(e) => { e.stopPropagation(); onApplyClick(job.id); }}
                className="flex-shrink-0 bg-gray-900 text-white rounded-xl border-2 border-gray-900 px-3 py-2 text-xs font-black hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                להגשת מועמדות
              </button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
